module.exports = __webpack_public_path__ + "img/khk_logo.4167c83e.jpg";